import {FALLBACK_SECTIONS} from '../constants';

const EMPTY_TRANSFORMED_SECTIONS = [];

export const transformApiSections = (apiSections) => {
  if (!apiSections || !Array.isArray(apiSections) || apiSections.length === 0) {
    return EMPTY_TRANSFORMED_SECTIONS;
  }

  return [...apiSections] // Create a copy to avoid mutating read-only array
    .sort((a, b) => a.sortOrder - b.sortOrder)
    .map((section, index) => {
      const transformed = {
        id: section.sk,
        field: section.slug,
        title: section.name,
        sortOrder: section.sortOrder,
        slug: section.slug,
        index,
      };
      if (section.templateId != null) {
        transformed.templateId = section.templateId;
      }
      if (section.templateSnapshot != null) {
        transformed.templateSnapshot = section.templateSnapshot;
      }
      if (typeof section.isRotated === 'boolean') {
        transformed.isRotated = section.isRotated;
      }
      return transformed;
    });
};

/**
 * Returns the first section id for the given API sections (same as useDocumentSections would).
 * Use this when you only need the initial active editor id without running the full hook.
 */
export const getFirstSectionId = (apiSections = []) => {
  const sections =
    apiSections && apiSections.length > 0
      ? transformApiSections(apiSections)
      : FALLBACK_SECTIONS;
  return sections[0]?.id;
};
